"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GeoJsonEditMode", {
  enumerable: true,
  get: function get() {
    return _geojsonEditMode.GeoJsonEditMode;
  }
});
Object.defineProperty(exports, "ModifyMode", {
  enumerable: true,
  get: function get() {
    return _modifyMode.ModifyMode;
  }
});
Object.defineProperty(exports, "ResizeCircleMode", {
  enumerable: true,
  get: function get() {
    return _resizeCircleMode.ResizeCircleMode;
  }
});
Object.defineProperty(exports, "TranslateMode", {
  enumerable: true,
  get: function get() {
    return _translateMode.TranslateMode;
  }
});
Object.defineProperty(exports, "ScaleMode", {
  enumerable: true,
  get: function get() {
    return _scaleMode.ScaleMode;
  }
});
Object.defineProperty(exports, "RotateMode", {
  enumerable: true,
  get: function get() {
    return _rotateMode.RotateMode;
  }
});
Object.defineProperty(exports, "DuplicateMode", {
  enumerable: true,
  get: function get() {
    return _duplicateMode.DuplicateMode;
  }
});
Object.defineProperty(exports, "ExtendLineStringMode", {
  enumerable: true,
  get: function get() {
    return _extendLineStringMode.ExtendLineStringMode;
  }
});
Object.defineProperty(exports, "SplitPolygonMode", {
  enumerable: true,
  get: function get() {
    return _splitPolygonMode.SplitPolygonMode;
  }
});
Object.defineProperty(exports, "ExtrudeMode", {
  enumerable: true,
  get: function get() {
    return _extrudeMode.ExtrudeMode;
  }
});
Object.defineProperty(exports, "ElevationMode", {
  enumerable: true,
  get: function get() {
    return _elevationMode.ElevationMode;
  }
});
Object.defineProperty(exports, "TransformMode", {
  enumerable: true,
  get: function get() {
    return _transformMode.TransformMode;
  }
});
Object.defineProperty(exports, "DrawPointMode", {
  enumerable: true,
  get: function get() {
    return _drawPointMode.DrawPointMode;
  }
});
Object.defineProperty(exports, "DrawLineStringMode", {
  enumerable: true,
  get: function get() {
    return _drawLineStringMode.DrawLineStringMode;
  }
});
Object.defineProperty(exports, "DrawPolygonMode", {
  enumerable: true,
  get: function get() {
    return _drawPolygonMode.DrawPolygonMode;
  }
});
Object.defineProperty(exports, "DrawRectangleMode", {
  enumerable: true,
  get: function get() {
    return _drawRectangleMode.DrawRectangleMode;
  }
});
Object.defineProperty(exports, "DrawRectangleFromCenterMode", {
  enumerable: true,
  get: function get() {
    return _drawRectangleFromCenterMode.DrawRectangleFromCenterMode;
  }
});
Object.defineProperty(exports, "DrawSquareFromCenterMode", {
  enumerable: true,
  get: function get() {
    return _drawSquareFromCenterMode.DrawSquareFromCenterMode;
  }
});
Object.defineProperty(exports, "DrawCircleByDiameterMode", {
  enumerable: true,
  get: function get() {
    return _drawCircleByDiameterMode.DrawCircleByDiameterMode;
  }
});
Object.defineProperty(exports, "DrawCircleFromCenterMode", {
  enumerable: true,
  get: function get() {
    return _drawCircleFromCenterMode.DrawCircleFromCenterMode;
  }
});
Object.defineProperty(exports, "DrawEllipseByBoundingBoxMode", {
  enumerable: true,
  get: function get() {
    return _drawEllipseByBoundingBoxMode.DrawEllipseByBoundingBoxMode;
  }
});
Object.defineProperty(exports, "DrawEllipseUsingThreePointsMode", {
  enumerable: true,
  get: function get() {
    return _drawEllipseUsingThreePointsMode.DrawEllipseUsingThreePointsMode;
  }
});
Object.defineProperty(exports, "DrawRectangleUsingThreePointsMode", {
  enumerable: true,
  get: function get() {
    return _drawRectangleUsingThreePointsMode.DrawRectangleUsingThreePointsMode;
  }
});
Object.defineProperty(exports, "Draw90DegreePolygonMode", {
  enumerable: true,
  get: function get() {
    return _draw90degreePolygonMode.Draw90DegreePolygonMode;
  }
});
Object.defineProperty(exports, "DrawPolygonByDraggingMode", {
  enumerable: true,
  get: function get() {
    return _drawPolygonByDraggingMode.DrawPolygonByDraggingMode;
  }
});
Object.defineProperty(exports, "ImmutableFeatureCollection", {
  enumerable: true,
  get: function get() {
    return _immutableFeatureCollection.ImmutableFeatureCollection;
  }
});
Object.defineProperty(exports, "ViewMode", {
  enumerable: true,
  get: function get() {
    return _viewMode.ViewMode;
  }
});
Object.defineProperty(exports, "MeasureDistanceMode", {
  enumerable: true,
  get: function get() {
    return _measureDistanceMode.MeasureDistanceMode;
  }
});
Object.defineProperty(exports, "MeasureAreaMode", {
  enumerable: true,
  get: function get() {
    return _measureAreaMode.MeasureAreaMode;
  }
});
Object.defineProperty(exports, "MeasureAngleMode", {
  enumerable: true,
  get: function get() {
    return _measureAngleMode.MeasureAngleMode;
  }
});
Object.defineProperty(exports, "CompositeMode", {
  enumerable: true,
  get: function get() {
    return _compositeMode.CompositeMode;
  }
});
Object.defineProperty(exports, "SnappableMode", {
  enumerable: true,
  get: function get() {
    return _snappableMode.SnappableMode;
  }
});
Object.defineProperty(exports, "_memoize", {
  enumerable: true,
  get: function get() {
    return _memoize["default"];
  }
});
exports.utils = void 0;

var _geojsonEditMode = require("./lib/geojson-edit-mode");

var _modifyMode = require("./lib/modify-mode");

var _resizeCircleMode = require("./lib/resize-circle-mode");

var _translateMode = require("./lib/translate-mode");

var _scaleMode = require("./lib/scale-mode");

var _rotateMode = require("./lib/rotate-mode");

var _duplicateMode = require("./lib/duplicate-mode");

var _extendLineStringMode = require("./lib/extend-line-string-mode");

var _splitPolygonMode = require("./lib/split-polygon-mode");

var _extrudeMode = require("./lib/extrude-mode");

var _elevationMode = require("./lib/elevation-mode");

var _transformMode = require("./lib/transform-mode");

var _drawPointMode = require("./lib/draw-point-mode");

var _drawLineStringMode = require("./lib/draw-line-string-mode");

var _drawPolygonMode = require("./lib/draw-polygon-mode");

var _drawRectangleMode = require("./lib/draw-rectangle-mode");

var _drawRectangleFromCenterMode = require("./lib/draw-rectangle-from-center-mode");

var _drawSquareFromCenterMode = require("./lib/draw-square-from-center-mode");

var _drawCircleByDiameterMode = require("./lib/draw-circle-by-diameter-mode");

var _drawCircleFromCenterMode = require("./lib/draw-circle-from-center-mode");

var _drawEllipseByBoundingBoxMode = require("./lib/draw-ellipse-by-bounding-box-mode");

var _drawEllipseUsingThreePointsMode = require("./lib/draw-ellipse-using-three-points-mode");

var _drawRectangleUsingThreePointsMode = require("./lib/draw-rectangle-using-three-points-mode");

var _draw90degreePolygonMode = require("./lib/draw-90degree-polygon-mode");

var _drawPolygonByDraggingMode = require("./lib/draw-polygon-by-dragging-mode");

var _immutableFeatureCollection = require("./lib/immutable-feature-collection");

var _viewMode = require("./lib/view-mode");

var _measureDistanceMode = require("./lib/measure-distance-mode");

var _measureAreaMode = require("./lib/measure-area-mode");

var _measureAngleMode = require("./lib/measure-angle-mode");

var _compositeMode = require("./lib/composite-mode");

var _snappableMode = require("./lib/snappable-mode");

var _memoize = _interopRequireDefault(require("./memoize"));

var utils = _interopRequireWildcard(require("./utils"));

exports.utils = utils;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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